import { ButtonColors } from 'types';
import { EventReportTotalRevenue } from 'store/api/event/types';

export const tabletTemplate = '1fr 1fr';
export const template = 'repeat(9, 1fr) 64px';
export const employeeTitles = ['Name', 'Gross Sales'];
export const usersTitles = ['Name', 'Created check out'];
export const titles = [
  'Dates',
  'Check',
  'Cash',
  'Net Credit',
  'Tip',
  'Taxes',
  'Fees',
  'Shipping',
  'Total',
  '',
];

export const commonButtonProps = {
  padding: '0',
  transparent: true,
  colorType: ButtonColors.BlackWhite,
};

const totalFields: { title: string; key: keyof EventReportTotalRevenue }[] = [
  { key: 'netSales', title: 'Net Sales' },
  { key: 'tax', title: 'Tax' },
  { key: 'tip', title: 'Tip' },
  { key: 'grossSales', title: 'Gross Sales' },
];

export const getTotalsInfo = (total: EventReportTotalRevenue) =>
  totalFields.map(({ key, title }) => ({ title, value: total[key] }));
